import { combineReducers } from 'redux';
import { pathOr, omit, uniq, path } from 'ramda';
import { createSelector } from 'reselect';
import memoize from 'lodash.memoize';

import { actions } from '../actions/secondHandBoardgames';

const byId = (state = {}, action) => {
  switch (action.type) {
    case actions.FETCH_SECOND_HAND_BOARDGAMES_SUCCESS:
    case actions.GET_SECOND_HAND_BOARDGAME_SUCCESS:
    case actions.FETCH_ALL_SECOND_HAND_BOARDGAMES_SUCCESS:
    case actions.MARK_BOARDGAME_AS_SOLD_SUCCESS:
    case actions.CREATE_SECOND_HAND_BOARDGAME_SUCCESS:
    case actions.UPDATE_SECOND_HAND_BOARDGAME_SUCCESS:
      return Object.assign(
        {},
        state,
        omit(['undefined'], pathOr({}, ['payload', 'entities', 'boardgames'], action))
      );
    default:
      return state;
  }
};

const ids = (state = [], action) => {
  switch (action.type) {
    case actions.FETCH_SECOND_HAND_BOARDGAMES_SUCCESS:
    case actions.FETCH_ALL_SECOND_HAND_BOARDGAMES_SUCCESS:
      return uniq([
        ...state,
        ...pathOr([], ['payload', 'result'], action),
      ]);
    case actions.GET_SECOND_HAND_BOARDGAME_SUCCESS:
      return uniq([
        ...state,
        path(['payload', 'result'], action)
      ]);
    default:
      return state;
  }
};

const loading = (state = false, action) => {
  switch (action.type) {
    case actions.FETCH_SECOND_HAND_BOARDGAMES_REQUEST:
    case actions.GET_SECOND_HAND_BOARDGAME_REQUEST:
    case actions.FETCH_ALL_SECOND_HAND_BOARDGAMES_REQUEST:
    case actions.MARK_BOARDGAME_AS_SOLD_REQUEST:
    case actions.CREATE_SECOND_HAND_BOARDGAME_REQUEST:
    case actions.UPDATE_SECOND_HAND_BOARDGAME_REQUEST:
      return true;
    case actions.FETCH_SECOND_HAND_BOARDGAMES_SUCCESS:
    case actions.FETCH_SECOND_HAND_BOARDGAMES_FAILED:
    case actions.GET_SECOND_HAND_BOARDGAME_SUCCESS:
    case actions.GET_SECOND_HAND_BOARDGAME_FAILED:
    case actions.FETCH_ALL_SECOND_HAND_BOARDGAMES_SUCCESS:
    case actions.FETCH_ALL_SECOND_HAND_BOARDGAMES_FAILED:
    case actions.MARK_BOARDGAME_AS_SOLD_SUCCESS:
    case actions.MARK_BOARDGAME_AS_SOLD_FAILED:
    case actions.CREATE_SECOND_HAND_BOARDGAME_SUCCESS:
    case actions.CREATE_SECOND_HAND_BOARDGAME_FAILED:
    case actions.UPDATE_SECOND_HAND_BOARDGAME_SUCCESS:
    case actions.UPDATE_SECOND_HAND_BOARDGAME_FAILED:
      return false;
    default:
      return state;
  }
};

const secondHandBoardgames = combineReducers({
  byId,
  ids,
  loading,
});

export default secondHandBoardgames;

const allSecondHandBoardgameIdsSelector = state => state.secondHandBoardgames.ids;
const secondHandBoardgamesSelector = state => state.secondHandBoardgames.byId;
export const loadingSelector = state => state.secondHandBoardgames.loading;

export const unsoldBoardgamesSelector = createSelector(
  allSecondHandBoardgameIdsSelector,
  secondHandBoardgamesSelector,
  (ids, boardgames) => ids
    .map(id => Object.assign({}, boardgames[id]))
    .filter(bg => !bg.sold)
);

export const allBoardgamesSelector = createSelector(
  allSecondHandBoardgameIdsSelector,
  secondHandBoardgamesSelector,
  (ids, boardgames) => ids
    .map(id => Object.assign({}, boardgames[id]))
);

export const boardgameSelector = createSelector(
  secondHandBoardgamesSelector,
  boardgames => memoize(
    id => id && boardgames[id]
  )
);